module.exports = __webpack_public_path__ + "static/11-3002d724741dc3e8d09609157f6074fe.jpg";